import icons from '../../../icons';
import widgets from '../../widgets';


/**
 * returns a 'add new state' button to add a new fsm state to the instruction card.
 * @param {Object} params
 * @param {() => void} params.onAddNewState callback to add a new fsm state
 * @returns {JQuery<HTMLElement>}
 */
export const addNewStateButton = ({onAddNewState}) => {
  return widgets.inlineButtonWithText(
    icons.addPlus,
    'Add New State',
    onAddNewState
  ).addClass('ml_fsm_add_new_state_button');
};
